import type { ToolDto, StoreToolResponseDto } from '@api/generated/models';
import type { Tool, StoreToolResponse } from '@api/domain/types';

export const toTool = (dto: ToolDto): Tool => dto;
export const toTools = (dtos: ToolDto[]): Tool[] => dtos.map(toTool);
export const toStoreToolResponse = (dto: StoreToolResponseDto): StoreToolResponse => dto;
